// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ixptmC","image":"_2u74lcb","link":"_19nklES"};